'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = addressBook;

var _lodash = require('lodash');

var _actions = require('../helpers/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
  addresses: [],
  selectedAddresses: [],
  populated: false,
  postcodeError: false
};

var setSelected = function setSelected(state, action) {
  var selectedAddresses = state.selectedAddresses,
      restOf = (0, _objectWithoutProperties3.default)(state, ['selectedAddresses']);

  var a = (0, _lodash.cloneDeep)(selectedAddresses);
  a.push({ id: action.addressId, type: action.addressType });
  return (0, _extends3.default)({}, restOf, { selectedAddresses: (0, _lodash.uniq)(a) });
};

function addressBook() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'QUERY_ADDRESS_BOOK':
      return state;
    case 'QUERY_ADDRESS_BOOK_SUCCESS':
      return action.result;
    case 'QUERY_ADDRESS_BOOK_FAILURE':
      return (0, _extends3.default)({}, state, { error: (0, _actions.serializableError)(action.error) });
    case 'SET_ADDRESS_BOOK_SELECTED':
      return setSelected(state, action);
    case 'DELETE_ADDRESS':
      return state;
    case 'DELETE_ADDRESS_SUCCESS':
      return state;
    case 'DELETE_ADDRESS_FAILURE':
      return (0, _extends3.default)({}, state, { error: (0, _actions.serializableError)(action.error) });
    case 'SET_POSTCODE_ERROR':
      return (0, _extends3.default)({}, state, { postcodeError: true });
    case 'REMOVE_POSTCODE_ERROR':
      return (0, _extends3.default)({}, state, { postcodeError: false });
    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/reducers/addressBook.js
// module id = 2524
// module chunks = 0